import React, { useEffect, useState } from 'react';

// project-imports
import SEO from '../../common/SEO';
import Layout from '../../common/Layout';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import EBookListingOne from '../../components/ebooks/EBookTypeOne';
import EBookSearchOne from '../../components/widgets/blog/EBookSearchOne';
import ErrorComponent from '../../components/error-message/ErrorComponent';
import EBookCategoryOne from '../../components/widgets/blog/EBookCategoryOne';
import EBookListingOneStencil from '../../components/ebooks/EBookTypeOneStencil';
import { useProductContext } from '../../context/product_context';
import { GoogleAnalyticsEnum, pageView } from '../../utils/google-analytics';
import { ADMIN, DEV } from '../../constants/entityType';
// import EBookListingOne from '../../components/ebooks/EBookListingOne';
// import EBookListingOneStencil from '../../components/ebooks/EBookListingOneStencil';


// third-party
import { useParams, useNavigate } from 'react-router-dom';
import EBookListingHome from '../../components/ebooks/EBookListingHome';
import EBookListingThreeStencil from '../../components/ebooks/EBookListingThreeStencil';
import EBookListingsStencil from './EBookListingsStencil';

const EBookListings = () => {

    // Property initialization
    const { type = "paid", productCode } = useParams();
    const navigate = useNavigate();

    const { ebooks, productsError, productLoading, setFilteredEBooks, searchTerm, filteredEBooks } = useProductContext();

    // Reading from plans data
    // const { paid, salesforceAdmin } = plans;

    const paid = ((filteredEBooks && filteredEBooks.length) || searchTerm ? filteredEBooks?.filter((item) => item?.pricing.price > 0) : ebooks?.filter((item) => item?.pricing.price > 0)) || [];
    const free = ((filteredEBooks && filteredEBooks.length) || searchTerm ? filteredEBooks?.filter((item) => item?.pricing.price <= 0 || (item?.discount?.hasDiscount && item?.discount?.discountPercent === 100)) : ebooks?.filter((item) => item?.pricing.price <= 0 || (item?.discount?.hasDiscount && item?.discount?.discountPercent === 100))) || [];

    // State variable initialization 
    const [state, setState] = useState({
        active: type,
        pricingPlan: type === "paid" ? paid : free,
    });
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [inputValue, setInputValue] = useState("");

    const categorizedData = selectedCategory?.cat && selectedCategory?.subCat ? state.pricingPlan.filter((item) => {
        const cat = item && item?.category.toLowerCase();
        const subCat = item && item?.subCategory?.toLowerCase() === ADMIN ? item?.subCategory.toLowerCase() : DEV;
        const selectCat = selectedCategory && selectedCategory?.cat.toLowerCase();
        const selectSubCat = selectedCategory && selectedCategory?.subCat.toLowerCase();
        return cat === selectCat && subCat === selectSubCat;
    }) : state.pricingPlan;

    const sortedData = [...categorizedData].sort(
        (a, b) =>
            new Date(b.metadata?.createdAt) - new Date(a.metadata?.createdAt)
    );

    // Constant functions
    const handleChange = (event) => {
        try {
            setInputValue(event.target.value);
            setFilteredEBooks(event.target.value);
        } catch (error) {
            console.log("58 : EBookListings : Error in handleChange : ", error && JSON.stringify(error));
        }
    };

    const handlePricing = (plan) => {
        try {
            if (plan === 'free') {
                setState({
                    ...state,
                    active: 'free',
                    pricingPlan: free
                });
                navigate("/our-resources/free");
            } else {
                setState({
                    ...state,
                    active: 'paid',
                    pricingPlan: paid
                });
                navigate("/our-resources/paid");
            }
        } catch (error) {
            console.log("80 : EBookListings : Error in handlePricing : ", error && JSON.stringify(error));
        }
    }

    const handleCategoryChange = (category) => {
        try {
            setSelectedCategory((prev) => (prev?.cat === category?.cat && prev?.subCat === category?.subCat ? {} : category));
        } catch (error) {
            console.log("88 : EBookListings : Error in handleCategoryChange : ", error && JSON.stringify(error));
        }
    }

    const handleResetFilters = () => {
        try {
            setFilteredEBooks("");
            setSelectedCategory(null);
            setInputValue("");
            window.scrollTo({ top: 0, behavior: "smooth" });
        } catch (error) {
            console.log("99 : EBookListings : Error in handleResetFilters : ", error && JSON.stringify(error));
        }
    }

    useEffect(() => {
        setState({ ...state, active: type, pricingPlan: type === 'free' ? free : paid });
    }, [ebooks, type, searchTerm, filteredEBooks]);

    // Reset the search term on page change
    useEffect(() => {
        return () => {
            // Reset when leaving page
            setFilteredEBooks("");
        };
    }, []);

    if (productLoading) {
        // Loading stencil 
        return <EBookListingsStencil />
    }

    return (
        <>
            <SEO title="E-Books | Longswitch Academy" url={process.env.REACT_APP_META_URL + "e-books"} /> {/* Set SEO title */}
            {pageView(window.location.pathname, GoogleAnalyticsEnum.SF_ALL_RESOURCES)}
            <Layout>
                <BreadcrumbOne
                    title="Our E-Books" // Breadcrumb title
                    rootUrl="/"
                    parentUrl="Home"
                    googleEnum={GoogleAnalyticsEnum.SF_ALL_COURSES_TO_SF_COURSE_HOME}
                    currentUrl="E-Books"
                    extraClass="container-xs"
                />
                <div className="edu-elements-area edu-course-area edu-section-gap bg-color-white pb-150">
                    <div className="container container-xs edu-course-area">
                        <div className="row g-5">
                            <div className="col-lg-6">
                                <div className="section-title text-start">
                                    <span className="pre-title">Salesforce Learning Resources Library</span>
                                    <h3 className="title">Curated Salesforce E-Books</h3>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                {!productsError ?
                                    <div className="pricing-billing-duration">
                                        <ul>
                                            <li className="nav-item">
                                                <button
                                                    className={state.active === 'free' ? 'nav-link active' : 'nav-link'}
                                                    type="button"
                                                    aria-label="free"
                                                    onClick={() => handlePricing('free')}
                                                >
                                                    Free
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    className={state.active === 'paid' ? 'nav-link active' : 'nav-link'}
                                                    type="button"
                                                    aria-label="paid"
                                                    onClick={() => handlePricing('paid')}
                                                >
                                                    Paid
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                    :
                                    <></>
                                }
                            </div>
                        </div>
                        <div className="row y-gap-40 pt--50">

                            {/* Right side bar Ebook Listing */}
                            <div className="col-lg-9 order-2">
                                <div className="row y-gap-40 ">
                                    {(!productLoading && productsError) ?
                                        <div className="col-12 text-center">
                                            <ErrorComponent errorCode="500" mainError="No resources are available!" subText="Currently no resources are available. Please be back later." buttonText="Back to Home" link='/' />
                                        </div>
                                        :
                                        ((!productLoading && !productsError && (!state.pricingPlan || (state.pricingPlan && !state.pricingPlan?.length))) || (!sortedData || (sortedData && !sortedData?.length))) ?
                                            <div className="col-12">
                                                <div className="text-center">
                                                    <ErrorComponent errorCode="404" mainError="No E-Books Available" subText="No E-Books are found. Try adjusting your search criteria." buttonText="Reset Search" link={`/our-resources/${state?.active}`} onBtnClick={handleResetFilters} />
                                                </div>
                                            </div>
                                            :
                                            (sortedData.map((item, index) => (
                                                <div className="col-12 col-sm-6 col-lg-4 border-bottom-1" key={index}>
                                                    {/* <EBookListingOne data={item} activeStatus={state?.active} code={productCode} /> */}
                                                    <EBookListingHome data={item} activeStatus={state?.active} code={productCode} />
                                                </div>
                                            )))
                                    }
                                </div>
                            </div>

                            {/* Left side bar (Search & Category) */}
                            {
                                (!productLoading && !productsError) &&
                                <div className="col-lg-3">
                                    <aside className="edu-blog-sidebar">
                                        {/* Search component */}
                                        <EBookSearchOne handleEBookSearch={handleChange} inputText={inputValue} />
                                        {/* category widget */}
                                        <EBookCategoryOne extraClass="mt--50" style2="enable"
                                            ebooks={state?.pricingPlan || []}
                                            allEbooks={ebooks}
                                            handleChangeCategory={handleCategoryChange}
                                            selectedCategory={selectedCategory}
                                        />
                                    </aside>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default EBookListings;